import { render } from "./Summary.vue?vue&type=template&id=5f97552e&scoped=true"
import script from "./Summary.vue?vue&type=script&lang=js"
export * from "./Summary.vue?vue&type=script&lang=js"

import "./Summary.vue?vue&type=style&index=0&id=5f97552e&scoped=true&lang=css"

import exportComponent from "/home/noe/Dev/atc/agrotecchain_vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f97552e"]])

export default __exports__